import type { ListRecurrencesParams } from '@frontend/api-types';
import { formatEndpoint } from '@frontend/duck-tape';

const namespace = 'recurrences';

const ACCESS = 'access';

const RECURRENCES_ENDPOINTS = {
  // TODO: (Abdul) Currently share/unshare & predict recurrences API doesn't have a trailing slash, would change it when the API is updated
  accessRecurrence: (id: string, clientId: string) => `${namespace}/${id}/${ACCESS}/${clientId}`,
  listRecurrences: (params: ListRecurrencesParams | void) =>
    formatEndpoint(
      'client/v2',
      namespace,
      params
        ? {
            queryParams: {
              suggestion_type: params.suggestionType,
            },
          }
        : undefined,
    ),
  predictRecurrence: (sourceTaskId: string) => `${namespace}/predict_from_task/${sourceTaskId}`,
  retrieveRecurrence: (id: string) => formatEndpoint(`client/v2/${id}`, namespace),
};

export default RECURRENCES_ENDPOINTS;
